// extracted by mini-css-extract-plugin
export var icon = "equipmentServices-module--icon--ead6e";
export var serviceWrapper = "equipmentServices-module--serviceWrapper--d2f20";
export var wrapper = "equipmentServices-module--wrapper--1d5ea";